import { render, staticRenderFns } from "./subjectClass.vue?vue&type=template&id=1da49f58&scoped=true&"
import script from "./subjectClass.vue?vue&type=script&lang=js&"
export * from "./subjectClass.vue?vue&type=script&lang=js&"
import style0 from "./subjectClass.vue?vue&type=style&index=0&id=1da49f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da49f58",
  null
  
)

export default component.exports